import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { heroDogImage, guaranteeLine } from '../data/content';
import { Heading } from './Primitives';
import { Logo } from './Logo';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-cream px-5 pb-12 pt-10 sm:px-8 sm:pb-16 sm:pt-14" data-id="element-58" data-mp="9ipbpaa4vbzl">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-28 h-72 w-72 rounded-full bg-orangey-100/70 blur-3xl" data-id="element-59" data-mp="4jvwndf77cxb" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-28 -left-24 h-72 w-72 rounded-full bg-teal-50 blur-3xl" data-id="element-60" data-mp="xaxfppm0hsm4" />

      <div className="relative mx-auto w-full max-w-5xl" data-id="element-61" data-mp="ncq13df73mna">
        <Logo size="lg" showTagline className="mx-auto w-fit flex-col text-center lg:mx-0 lg:flex-row lg:text-left" data-id="element-62" data-mp="neaw145f97lo" />

        <div className="mt-8 flex flex-col gap-8 lg:grid lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-10" data-id="element-63" data-mp="382fern45x2ee">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          ease: 'easeOut'
        }} className="order-1 text-center lg:col-start-1 lg:text-left" data-id="element-64" data-mp="3j8sfs1yzrlqd">
            <span className="inline-flex items-center gap-2 rounded-2xl border border-orangey-100 bg-white px-4 py-2 font-mono text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-ink-500 shadow-soft sm:text-xs" data-id="element-65" data-mp="39a36uyp2pbm9">
              🐾 Your dog's personal nutrition assistant
            </span>

            <Heading as="h1" size="xl" className="mt-5" data-id="element-66" data-mp="35a2gqgsm3bzd">
              Stop guessing. Know what your dog needs.
            </Heading>

            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-500 lg:mx-0 sm:text-xl" data-id="element-67" data-mp="2viy3pmmhy176">
              You love your dog. But how much food? How many treats? Enough water? A healthy weight?
            </p>
            <p className="mx-auto mt-3 max-w-xl text-lg leading-relaxed text-ink-500 lg:mx-0 sm:text-xl" data-id="element-68" data-mp="2ll0f2y0q62e1">
              Pawsy creates personalized daily nutrition and care guidance based on your dog's age, weight, activity
              and goals.
            </p>

            <p className="mx-auto mt-4 max-w-xl font-semibold text-ink-700 lg:mx-0" data-id="element-69" data-mp="n9i35afexat2">
              Personalized portions · Water targets · Treat guidance · Weight guidance · Safe food answers
            </p>

            <div className="mt-6 flex flex-col items-center gap-3 lg:items-start" data-id="element-70" data-mp="1b0vubd1tv0cg">
              <a href="#inside" className="group inline-flex items-center gap-1.5 text-sm font-semibold text-ink-500 underline-offset-4 transition-colors hover:text-orangey-700 hover:underline" data-id="element-71" data-mp="1ayjilhmnxm7u">
                See what's inside
                <ArrowDownIcon className="h-4 w-4 transition-transform group-hover:translate-y-0.5" aria-hidden="true" data-id="element-72" data-mp="x0uwk6gv0917" />
              </a>
            </div>

            <p className="mt-4 font-mono text-[0.65rem] font-semibold uppercase tracking-[0.12em] text-ink-400" data-id="element-73" data-mp="3hqu1e72ly1zl">
              {guaranteeLine}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.12,
          ease: 'easeOut'
        }} className="order-2 mx-auto w-full max-w-[16rem] sm:max-w-[19rem] lg:col-start-2 lg:max-w-none" data-id="element-74" data-mp="21amwtbz2vwne">
            <div className="relative" data-id="element-75" data-mp="2g0bzxcqqeaqb">
              <div aria-hidden="true" className="absolute inset-0 -rotate-6 rounded-[46%_54%_58%_42%/48%_42%_58%_52%] bg-orangey-100" data-id="element-76" data-mp="2fzamx2q5ne5y" />
              <img src={heroDogImage} alt="A happy golden dog sitting in soft natural light, looking at the camera" className="relative w-full rounded-[48%_52%_44%_56%/52%_46%_54%_48%] object-cover shadow-soft" data-id="element-77" data-mp="2p1jzdy4zhhlz" />
              <span className="absolute -bottom-2 left-1 flex items-center gap-2 rounded-2xl border border-orangey-100 bg-white px-3 py-2 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.12em] text-ink-500 shadow-card sm:left-2" data-id="element-78" data-mp="zl0yk8lwxpf4">
                🍽️ 742 kcal / day
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}